import { CommonActionTypes, CommonActions } from '@store/actions/common.actions';
import { IPulseType } from '@shared/models/entities';
import * as Enums from '@shared/resources/PulseTypes';

export interface PulseTypeState {
    howHeardAboutTypes?: IPulseType[] | null;
    countryTypes?: IPulseType[] | null;
    suffixTypes?: IPulseType[] | null;
    contactMethodTypes?: IPulseType[] | null; // TODO: convert to lower case properties
    usStateTypes?: IPulseType[] | null;
    canadaProvinceTypes?: IPulseType[] | null;
    timeZoneTypes?: IPulseType[] | null;
    metroAreaTypes?: IPulseType[] | null;
    schoolDegreeTypes?: IPulseType[] | null;
}

export const initialState: PulseTypeState = {
    howHeardAboutTypes: null,
    countryTypes: null,
    suffixTypes: null,
    contactMethodTypes: null,
    usStateTypes: null,
    canadaProvinceTypes: null,
    timeZoneTypes: null,
    metroAreaTypes: null,
    schoolDegreeTypes: null
};

// const initialState: PulseTypeState = pulseTypeAdapter.getInitialState();

export function reducer(
    state = initialState,
    action: CommonActions
): PulseTypeState {
    switch (action.type) {
        case CommonActionTypes.GetHowHeardAboutTypesSuccess:
            return {
                ...state,
                howHeardAboutTypes: action.payload
            };
        case CommonActionTypes.GetCountryTypesSuccess:
            return {
                ...state,
                countryTypes: action.payload
            };
        case CommonActionTypes.GetSuffixTypesSuccess:
            return {
                ...state,
                suffixTypes: action.payload
            };
        case CommonActionTypes.GetContactMethodTypesSuccess:
            return {
                ...state,
                contactMethodTypes: <IPulseType[]>action.payload
            };
        case CommonActionTypes.GetUSStateTypesSuccess:
            return {
                ...state,
                usStateTypes: <IPulseType[]>action.payload
            };
        case CommonActionTypes.GetCanadaProvinceTypesSuccess:
            return {
                ...state,
                canadaProvinceTypes: <IPulseType[]>action.payload
            };
        case CommonActionTypes.GetTimeZoneTypesSuccess:
            return {
                ...state,
                timeZoneTypes: <IPulseType[]>action.payload
            };
        case CommonActionTypes.GetMetroAreaTypesSuccess:
            return {
                ...state,
                metroAreaTypes: <IPulseType[]>action.payload
            };
        case CommonActionTypes.GetSchoolDegreeTypesSuccess:
            return {
                ...state,
                schoolDegreeTypes: <IPulseType[]>action.payload
            };
        default:
            return state;
    }
}

export const getHowHeardAboutTypes = (state: PulseTypeState) => state.howHeardAboutTypes;
export const getCountryTypes = (state: PulseTypeState) => state.countryTypes;
export const getSuffixTypes = (state: PulseTypeState) => state.suffixTypes;
export const getContactMethodTypes = (state: PulseTypeState) => state.contactMethodTypes;
export const getPhoneTypes = (state: PulseTypeState) => {
    return state.contactMethodTypes ? state.contactMethodTypes.filter(
        t => t.typeID <= Enums.ContactMethodType.CellPhone
    ) : null;
}

export const getUSStateTypes = (state: PulseTypeState) => {
    return state.usStateTypes ? state.usStateTypes.filter(s => {
        if (s.typeID !== Enums.USStateType.International) {
            return s;
        }
    }) : null;
}

export const getCanadaProvinceTypes = (state: PulseTypeState) => state.canadaProvinceTypes;
export const getTimeZoneTypes = (state: PulseTypeState) => state.timeZoneTypes;
export const getMetroAreaTypes = (state: PulseTypeState) => state.metroAreaTypes;
export const getSchoolDegreeTypes = (state: PulseTypeState) => state.schoolDegreeTypes;

